import { Fragment, type FC } from 'react';

import { type LoggingContext } from '#packages/data-collection/types/logging-context';
import { type ViewModelProps } from '#packages/web/types/view-model-props';
import { LoadingPage } from '#packages/web/layouts/page/templates';

import { ThrowError } from '#apps/client-web/app/components/throw-error';

import { type AuditSettingsPageViewModel } from './audit-settings-page.view-model';
import { AuditSettingsPageRenderer } from './audit-settings-page.renderer';

export type AuditSettingsPageContainerProps =
  ViewModelProps<AuditSettingsPageViewModel> & LoggingContext;

export const AuditSettingsPageContainer: FC<
  AuditSettingsPageContainerProps
> = ({ viewModel }) => {
  const { loadAuditDetailsState, updateMutationState, form, onSubmit } =
    viewModel;

  return (
    <Fragment>
      {/* Loading */}
      {loadAuditDetailsState.state === 'loading' && <LoadingPage />}

      {/* Success */}
      {loadAuditDetailsState.state === 'success' && (
        <AuditSettingsPageRenderer
          form={form}
          onSubmit={onSubmit}
          isPending={updateMutationState.state === 'pending'}
        />
      )}

      {/* Error */}
      {loadAuditDetailsState.state === 'error' && (
        <ThrowError error={loadAuditDetailsState.error} />
      )}

      {/* Mutation error */}
      {updateMutationState.state === 'error' && (
        <ThrowError error={updateMutationState.error} />
      )}
    </Fragment>
  );
};
